import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fce5588"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["rel", "target", "href"]

import { computed, toRefs } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

interface Props {
  to: Record<string, string> | string | RouteLocationRaw
  target?: '_blank' | '_self' | '_parent' | '_top'
  isUnderlined?: boolean
  color?: 'white' | 'teal'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLink',
  props: {
    to: null,
    target: null,
    isUnderlined: { type: Boolean, default: true },
    color: { default: 'white' }
  },
  setup(__props: any) {

const props = __props as { to: Record<string, string> | string | RouteLocationRaw, target?: '_blank' | '_self' | '_parent' | '_top', isUnderlined: boolean, color: 'white' | 'teal' };


const { to, target, isUnderlined, color } = toRefs(props)

const isOpenedInNewTab = computed(() => target?.value === '_blank')
const isLocalLink = computed(() => typeof to.value === 'object')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLocalLink))
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: _unref(to),
        class: _normalizeClass(['base-link', `base-link--color-${_unref(color)}`, { 'base-link--no-underline': !_unref(isUnderlined) }]),
        "active-class": "is-active",
        "exact-active-class": "is-exact-active"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to", "class"]))
    : (_openBlock(), _createElementBlock("a", {
        key: 1,
        rel: _unref(isOpenedInNewTab) ? 'noopener noreferrer' : '',
        target: _unref(target),
        href: (_unref(to) as string),
        class: _normalizeClass(['base-link', `base-link--color-${_unref(color)}`, { 'base-link--no-underline': !_unref(isUnderlined) }])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1))
}
}

})